import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  constructor(
    private _http: HttpClient
  ) {

  }

  public getAllCatalogs(apiKey: string, network: string): Promise<any> {
    try {
      const api = `${environment.catalog}${apiKey}/catalogs?with_network_catalogs=true&tags_expr=${network}`;
      return this._http.get(api).toPromise().then(
        (response: any) => {
          if (response && !response.error) {
            const catalogs = response.result.map((x: any) => JSON.parse(x));
            catalogs.sort((a, b) => {
              return (a.createdAt > b.createdAt) ? -1 : (a.createdAt < b.createdAt) ? 1 : 0;
            });
            return Promise.resolve(catalogs);
          } else {
            return Promise.reject("API ERROR");
          }
        },
        (error) => {
          return Promise.reject("Couldn't get catalogs.")
        }
      );
    } catch (error: any) {
      console.error(error);
      return Promise.reject("GENERIC ERROR");
    }
  }

  public getCatalogByIdAndApiKey(catalogId: string, apiKey: string, receiveSlimCatalog: boolean = false): Promise<any> {
    try {
      let api: string;
      if(receiveSlimCatalog){
        const queryParams = { name: '$.name', image: '$.pages[0].sections[0].content.image.url', style:'$.style_rules.page_css_class' };
        api = `${environment.catalog}${apiKey}/catalog/${catalogId}?field_proj=${queryParams.name},${queryParams.image},${queryParams.style}`;
      } else {
        api = `${environment.catalog}${apiKey}/catalog/${catalogId}`;
      }
      return this._http.get(api).toPromise().then(
        (response: any) => {
          if (response && !response.error) {
            const catalog = JSON.parse(response.result);
            return Promise.resolve(catalog);
          } else {
            return Promise.reject("API ERROR");
          }
        },
        (error) => {
          return Promise.reject("Couldn't get catalogs.")
        }
      );
    } catch (error: any) {
      console.error(error);
      return Promise.reject("GENERIC ERROR");
    }
  }
}
